"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var forwardAs_1 = __importDefault(require("@seaweb/coral/hoc/forwardAs"));
var BaseButton_1 = __importDefault(require("@seaweb/coral/components/BaseButton/BaseButton"));
var TipContext_1 = require("@seaweb/coral/components/Tip/TipContext");
var warnMissingIndex_1 = __importDefault(require("@seaweb/coral/utils/warnMissingIndex"));
var useWrapEvent_1 = __importDefault(require("@seaweb/coral/hooks/useWrapEvent"));
var useForkRef_1 = __importDefault(require("@seaweb/coral/hooks/useForkRef"));
var color_1 = require("@seaweb/coral/utils/color");
var MenuContext_1 = require("./MenuContext");
var WrappedBaseButton = forwardAs_1.default(BaseButton_1.default);
var StyledBaseButton = styled_1.default(WrappedBaseButton)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n  transition: all 0.2s ease;\n  position: relative;\n  height: 36px;\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  transition: all 0.2s ease;\n  position: relative;\n  height: 36px;\n\n  ",
    "\n"])), function (_a) {
    var _b = _a.theme, _c = _b.colors, primary = _c.primary, alternate = _c.alternate, spacing = _b.spacing, disabled = _a.disabled;
    return styled_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-left: ", "px;\n    padding-right: ", "px;\n    color: ", ";\n\n    ", "\n  "], ["\n    padding-left: ", "px;\n    padding-right: ", "px;\n    color: ", ";\n\n    ",
        "\n  "])), 4 * spacing.factor, 8 * spacing.factor, alternate, disabled
        ? styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), color_1.alp(alternate, 0.3)) : styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          &[data-focus-visible-added] {\n            background-color: ", ";\n          }\n\n          &[data-coral-hover],\n          &:hover {\n            background-color: ", ";\n          }\n\n          &[data-coral-pressed] {\n            background-color: ", ";\n            color: ", ";\n          }\n        "], ["\n          &[data-focus-visible-added] {\n            background-color: ", ";\n          }\n\n          &[data-coral-hover],\n          &:hover {\n            background-color: ", ";\n          }\n\n          &[data-coral-pressed] {\n            background-color: ", ";\n            color: ", ";\n          }\n        "])), color_1.alp(primary, 0.1), color_1.alp(primary, 0.05), color_1.alp(primary, 0.1), color_1.drk(primary, 10)));
});
var MenuItem = react_1.forwardRef(function MenuItem(_a, ref) {
    var as = _a.as, index = _a.index, _b = _a.role, role = _b === void 0 ? 'menuitem' : _b, disabled = _a.disabled, onKeyDown = _a.onKeyDown, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onClick = _a.onClick, _c = _a.closeOnClick, closeOnClick = _c === void 0 ? true : _c, props = __rest(_a, ["as", "index", "role", "disabled", "onKeyDown", "onMouseEnter", "onMouseLeave", "onClick", "closeOnClick"]);
    warnMissingIndex_1.default(index, 'MenuItem', 'Menu');
    var _d = MenuContext_1.useMenuContext(), setItemRef = _d.setItemRef, getRelativeTarget = _d.getRelativeTarget, rootButtonRef = _d.rootButtonRef, popupRef = _d.popupRef, setRootActive = _d.setRootActive, register = _d.register;
    var ownRef = react_1.useRef(null);
    var phase = TipContext_1.useTipContext().phase;
    var isEnterPhase = phase === 'enter';
    var handleRef = useForkRef_1.default(useForkRef_1.default(ref, ownRef), function (el) {
        if (isEnterPhase) {
            setItemRef(index, disabled ? null : el);
            register("item-" + index, el);
        }
    });
    var moveFocus = function (distance) {
        var _a = __read(getRelativeTarget(index, distance), 2), target = _a[0], targetIndex = _a[1];
        if (targetIndex !== index)
            target.focus();
    };
    var handleKeyDown = useWrapEvent_1.default(onKeyDown, function (e) {
        if (e.key === 'ArrowDown')
            moveFocus(1);
        if (e.key === 'ArrowUp')
            moveFocus(-1);
    });
    var handleMouseEnter = useWrapEvent_1.default(onMouseEnter, function () {
        if (isEnterPhase)
            ownRef.current.focus();
    });
    var handleMouseLeave = useWrapEvent_1.default(onMouseLeave, function () {
        if (isEnterPhase)
            popupRef.current.focus();
    });
    var handleOnClick = useWrapEvent_1.default(onClick, function () {
        if (closeOnClick) {
            setRootActive(false);
            requestAnimationFrame(function () {
                if (rootButtonRef.current)
                    rootButtonRef.current.focus();
            });
        }
    });
    return (react_1.default.createElement(StyledBaseButton, __assign({ _as: as, ref: handleRef, role: role, disabled: disabled, onKeyDown: handleKeyDown, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onClick: handleOnClick }, props)));
});
exports.default = MenuItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
